// extracted by mini-css-extract-plugin
export default {"row":"icon-select_row__jshxh","input":"icon-select_input__FYv-M","iconUrl":"icon-select_iconUrl__nL229","item":"icon-select_item__nWmEO","active":"icon-select_active__MJ39t"};